import { PageContent, PageHeader } from '@olytic/foundation';

export function NotFoundPage(): JSX.Element {
  return (
    <PageContent as="section" width="wide">
      <PageHeader title="Not found" subtitle="There is nothing at this address." />
    </PageContent>
  );
}
